/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

export const BooleanViewer = (props) => {
	const {Value} = props;
	return Value ? "Yes" : "No";
};